$(document).ready(function () {
    function trans(translation) {
        var language = document.documentElement.lang;
//
        return _.get(window.i18n, language + "." + translation);
    }
    var start = moment().subtract(29, 'days');
    var end = moment();
    function cb(start, end) {
        start = start.format('YYYY-MM-D');
        end = end.format('YYYY-MM-D');
        $('#dateRangePickerSpan').val(start + '_' + end);
        $("#from").val(start);
        $("#to").val(end);
        $.ajax({
            url: 'calcorderrange/' +  $('#dateRangePickerSpan').val(),
            type: "get",
            dataType: "json",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                $("#dateRangeOrderCount").text('');
                $("#dateRangeOrderCount").text(data);
                $("#ahrefOrderDate").attr("href", "/order/view?from="+start+"&to="+end)
            },
            error: function () {

            }
        });
    }

    $('#reportrange2').daterangepicker({
        onSelect: function(dateText) {
            console.log("Selected date: " + dateText + "; input's current value: " + this.value);
            $(this).change();
        }
    },cb);

    $('.drp-selected').on('span', function(){

    });



});